export const noticePresets = {
  tariffsHighVolume: {
    variant: 'info',
    icon: 'InfoIcon',
    message: 'El volumen de datos es muy alto para mostrar en la vista. Descarga el archivo para obtener las tarifas.',
    customIcon: 'ui-notice__icon--info'
  },
  recaudosServices: {
    variant: 'none',
    icon: 'none'
  },
  tariffsInfo: {
    variant: 'warning',
    icon: 'AlertTriangleIcon',
    customClass: 'mt-1 alert-msg d-flex align-items-center',
    size: '28'
  },
  tariffsExportInfo: {
    variant: 'none',
    icon: 'none',
    customClass: 'msj-info'
  }
}
